exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable td[data-v-6ae6130b] {\n  font-weight: 500;\n}", ""]);

// exports
